<div *ngIf="isDisplayed || isDisplayedForced" class="loader-box">
  <div class="loader-img img-fluid"></div>
</div>
